export enum TipoSacado {
  PROPRIETARIO = "PROPRIETARIO",
  INQUILINO = "INQUILINO",
  CLIENTE = "CLIENTE",
  FORNECEDOR = "FORNECEDOR",
  TODOS = "TODOS",
}

export const getTipoSacadoFormatado = (tipoSacado: TipoSacado) => {
  switch (tipoSacado) {
    case TipoSacado.PROPRIETARIO:
      return "Proprietário";
    case TipoSacado.INQUILINO:
      return "Inquilino";
    case TipoSacado.CLIENTE:
      return "Cliente";
    case TipoSacado.FORNECEDOR:
      return "Fornecedor";
    case TipoSacado.TODOS:
      return "Todos";
  }
};
